<template>
  <div id="section_candidat">
    <div class="flex flex-wrap mb-12 justify-center text-center">
      <div class="md:w-1/2 lg:w-1/3 w-full my-4"
           :class="{'cursor-not-allowed': (session.startup_application != null && session.startup_application.type=='Prélabel' && session.startup_application.user_id != session.user_auth.id)}">
        <div
          class="box-application relative rounded shadow-lg p-4 font-bold text-blue hover:opacity-75 h-full text-center mx-4"
          :class="{'opacity-25 cursor-not-allowed': (session.startup_application && session.startup_application.type=='Prélabel' && session.startup_application.status!=0),'opacity-60 hover:opacity-100':(session.startup_application && session.startup_application.status==0 && session.startup_application.type=='Prélabel')}"
        >
          <div class="p-6 text-center">
            <div class="font-bold text-xl text-red h-16">{{ $t("candidat.you_are_company") }}</div>
            <img
              class="h-24 bg-cover rounded-t lg:rounded-t-none lg:rounded-l text-center overflow-hidden"
              src="../../assets/img/cand/buildings-2.svg"
              alt="startup act action"
            />
          </div>
          <div class="p-4">
            <div class="flex text-2sm">
              <div class="w-1/2">
                <div class="mb-2">
                  <i class="fas fa-info-circle mr-2"></i>
                  <span class="text-grey inline-block">Status :</span>
                </div>
                <div
                  v-if="session.startup_application == null"
                  class="text-blue"
                >{{ $t("candidat.no_candidat") }}</div>
                <div v-else class="text-blue">
                  <div
                    v-if="session.startup_application.status == 0"
                  >{{ $t("candidat.candidat_draft") }}</div>
                  <div
                    v-else-if="session.startup_application.status != '0'"
                  >{{ $t("candidat.candidat_complete") }}</div>
                </div>
              </div>
              <div class="w-1/2">
                <div class="mb-2">
                  <i class="fas fa-calendar-alt mr-2"></i>
                  <span class="text-grey inline-block">{{ $t("candidat.deadline") }} :</span>
                </div>
                <div class="text-blue">
                  <span v-if="((session && session.application_session && session.application_session.status == '1')) 
                    && session.application_session != null && session.application_session.limit_date == false 
                    && (session.application_session.first_step_limit_date == true || session.application_session.first_step_status != '1')">
                    {{ $t("progBar.nextSession") }}
                  </span>
                  <span
                    v-else-if="session.application_session && session.application_session.first_step_end_date!=null && session.application_session.first_step_limit_date == false"
                  >
                
                  {{formatDate(session.application_session.first_step_end_date)}}
                </span>

                  <span v-else>--/--/--</span>
                </div>
              </div>
            </div>
          </div>
          <div class="p-4 text-center">
            <button
              v-if="session.startup_application != null  && session.startup_application.type =='Label'"
              @click="addCandidate('label')"
              class="bg-red hover:bg-red text-white font-bold py-2 px-4 rounded inline-flex items-center"
              :disabled="(session.startup_application != null  
              && (session.startup_application.user_id != session.user_auth.id)) 
              || session.application_session != null && session.application_session.status != '1' 
              || session.application_session != null && session.application_session.limit_date == true
              || session.application_session != null && session.application_session.status == '1' && session.application_session.limit_date == true"
            >
              <img
                class="fill-current w-4 h-4 mr-2"
                src="../../assets/img/cand/pencil-write.svg"
                alt="startup act action"
              />
              <span
                v-if="session.startup_application != null  && (session.startup_application.user_id == session.user_auth.id)"
              >{{ $t('candidat.edit_candidat') }}</span>
              <span
                v-else
              >{{ $t('candidat.edit_member_candidat') }}</span>
            </button>
            <sp-button
                v-else
                @click="addCandidate('label')"
                class="bg-red hover:bg-red text-white font-bold py-2 px-4 rounded inline-flex items-center"
                :disabled="(session.startup_application != null  
                && (session.startup_application.user_id != session.user_auth.id)) 
                || session.application_session != null && session.application_session.status != '1' 
                || session.application_session != null && session.application_session.limit_date == true
                || session.application_session != null && session.application_session.status == '1' && session.application_session.limit_date == true"
              >
                <img
                  class="fill-current w-4 h-4 mr-2"
                  src="../../assets/img/cand/Group Copy 2.svg"
                  alt="startup act action"
                />
                <span>{{ $t('candidat.new_candidat') }}</span>
              </sp-button>
            </div>
            <div class="px-6 text-center h-5">
              <sp-button
                v-if="(session.startup_application!=null && session.startup_application.type =='Label' && session.startup_application.status ==0 && session.startup_application.user_id == session.user_auth.id)"
                class="text-grey"
                @click="showDelete()"
              >
                <span>{{ $t('candidat.delete') }}</span>
              </sp-button>
          </div>
        </div>
      </div>

      <div class="md:w-1/2 lg:w-1/3 w-full my-4"
           :class="{'cursor-not-allowed': (session.startup_application != null && session.startup_application.type=='Label' && session.startup_application.user_id != session.user_auth.id)}">
        <div
          class="box-application relative rounded shadow-lg p-4 font-bold text-blue hover:opacity-75 h-full text-center mx-4"
          :class="{'opacity-25 cursor-not-allowed': (session.startup_application && session.startup_application.type=='Label' && session.startup_application.status!=0),'opacity-60 hover:opacity-100':(session.startup_application && session.startup_application.status==0 && session.startup_application.type=='Prélabel')}"
        >
          <div class="p-6 text-center">
            <div class="font-bold text-xl text-red h-16">{{ $t("candidat.you_are_not_Company") }}</div>
            <img
              class="h-24 bg-cover rounded-t lg:rounded-t-none lg:rounded-l text-center overflow-hidden"
              src="../../assets/img/cand/human-resources-businessman.svg"
              alt="startup act action"
            />
          </div>
          <div class="p-4">
            <div class="flex text-2sm">
              <div class="w-1/2">
                <div class="mb-2">
                  <i class="fas fa-info-circle mr-2"></i>
                  <span class="text-grey inline-block">Status :</span>
                </div>
                <div
                  v-if="(session.startup_application == null || session.startup_application.type =='Label')"
                  class="text-blue"
                >{{ $t("candidat.no_candidat") }}</div>
                <div v-else class="text-blue">
                  <div
                    v-if="session.startup_application.status == 0 && session.startup_application.type =='Prélabel' "
                  >{{ $t("candidat.candidat_draft") }}</div>
                  <div
                    v-else-if="session.startup_application.status != '0' && session.startup_application.type =='Prélabel'"
                  >{{ $t("candidat.candidat_complete") }}</div>
                </div>
              </div>
              <div class="w-1/2">
                <div class="mb-2">
                  <i class="fas fa-calendar-alt mr-2"></i>
                  <span class="text-grey inline-block">{{ $t("candidat.deadline") }} :</span>
                </div>
                <div class="text-blue">
                  <span v-if="((session && session.application_session && session.application_session.status == '1')) 
                    && session.application_session != null && session.application_session.limit_date == false 
                    && (session.application_session.first_step_limit_date == true || session.application_session.first_step_status != '1')">
                    {{ $t("progBar.nextSession") }}
                  </span>
                  <span
                    v-else-if="session.application_session && session.application_session.first_step_end_date!=null"
                  >
                 {{formatDate(session.application_session.first_step_end_date)}}</span>
                  <span v-else>--/--/--</span>
                </div>
              </div>
            </div>
          </div>
          <div>
            <div class="p-4 text-center">
              <sp-button
                v-if="session.startup_application != null  && session.startup_application.type =='Prélabel'"
                @click="addCandidate('prelabel')"
                class="bg-red hover:bg-red text-white font-bold py-2 px-4 rounded inline-flex items-center"
              >
                <img
                  class="fill-current w-4 h-4 mr-2"
                  src="../../assets/img/cand/pencil-write.svg"
                  alt="startup act action"
                />
                <span
                  v-if="session.startup_application != null  && (session.startup_application.user_id == session.user_auth.id) && session.application_session.first_step_limit_date == false"
                >{{ $t('candidat.edit_candidat') }}</span>
                <span
                  v-else
                >{{ $t('candidat.edit_member_candidat') }}</span>
              </sp-button>

              <sp-button
                v-else
                @click="addCandidate('prelabel')"
                class="bg-red hover:bg-red text-white font-bold py-2 px-4 rounded inline-flex items-center"
                :disabled="(session.startup_application != null  
                && (session.startup_application.user_id != session.user_auth.id)) 
                || session.application_session != null && session.application_session.status != '1' 
                || session.application_session != null && session.application_session.limit_date == true
                || session.application_session != null && session.application_session.status == '1' && session.application_session.limit_date == true"
              >
                <img
                  class="fill-current w-4 h-4 mr-2"
                  src="../../assets/img/cand/Group Copy 2.svg"
                  alt="startup act action"
                />
                <span>{{ $t('candidat.new_candidat') }}</span>
              </sp-button>
            </div>
            <div class="px-6 text-center h-5">
              <sp-button
                v-if="(session.startup_application!=null && session.startup_application.type =='Prélabel' && session.startup_application.status ==0 && session.startup_application.user_id == session.user_auth.id)"
                class="text-grey"
                @click="showDelete()"
              >
                <span>{{ $t('candidat.delete') }}</span>
              </sp-button>
            </div>
          </div>
        </div>
      </div>
      <div class="md:w-1/2 lg:w-1/3 w-full my-4"
           :class="{'cursor-not-allowed': (session.startup_application != null && session.startup_application.type=='Digital' && session.startup_application.user_id != session.user_auth.id )}">
        <div
          class="box-application relative rounded shadow-lg p-4 font-bold text-blue hover:opacity-75 h-full text-center mx-4"
          :class="{'opacity-25 cursor-not-allowed': (session.startup_application && session.startup_application.type=='Digital' && session.startup_application.status!=0 && edit_app == true),'opacity-60 hover:opacity-100':(session.startup_application && session.startup_application.status==0 && session.startup_application.type=='Digital')}"
        >
          <div class="p-6 text-center">
            <div class="font-bold text-xl text-red h-16">Digitalisation</div>
            <img
              class="h-24 bg-cover rounded-t lg:rounded-t-none lg:rounded-l text-center overflow-hidden"
              src="../../assets/img/cand/human-resources-businessman.svg"
              alt="startup act action"
            />
          </div>
          <div class="p-4">
            <div class="flex text-2sm">
              <div class="w-1/2">
                <div class="mb-2">
                  <i class="fas fa-info-circle mr-2"></i>
                  <span class="text-grey inline-block">Status :</span>
                </div>
                <div
                  v-if="(session.startup_application == null || session.startup_application.type =='Label')"
                  class="text-blue"
                >{{ $t("candidat.no_candidat") }}</div>
                <div v-else class="text-blue">
                  <div
                    v-if="session.startup_application.status == 0 && session.startup_application.type =='Prélabel' "
                  >{{ $t("candidat.candidat_draft") }}</div>
                  <div
                    v-else-if="session.startup_application.status != '0' && session.startup_application.type =='Prélabel'"
                  >{{ $t("candidat.candidat_complete") }}</div>
                </div>
              </div>
              <div class="w-1/2">
                <div class="mb-2">
                  <i class="fas fa-calendar-alt mr-2"></i>
                  <span class="text-grey inline-block">{{ $t("candidat.deadline") }} :</span>
                </div>
                <div class="text-blue">
                  <span v-if="((session && session.application_session && session.application_session.status == '1')) 
                    && session.application_session != null && session.application_session.limit_date == false 
                    && (session.application_session.first_step_limit_date == true || session.application_session.first_step_status != '1')">
                    {{ $t("progBar.nextSession") }}
                  </span>
                  <span
                    v-else-if="session.application_session && session.application_session.first_step_end_date!=null && session.application_session.first_step_limit_date == false"
                  >
                 {{formatDate(session.application_session.first_step_end_date)}}</span>
                  <span v-else>--/--/--</span>
                </div>
              </div>
            </div>
          </div>
          <div>
            <div class="p-4 text-center">
              <sp-button
                v-if="session.startup_application != null  && session.startup_application.type =='Digital'"
                @click="addCandidate('digital')"
                class="bg-red hover:bg-red text-white font-bold py-2 px-4 rounded inline-flex items-center"
              >
                <img
                  class="fill-current w-4 h-4 mr-2"
                  src="../../assets/img/cand/pencil-write.svg"
                  alt="startup act action"
                />
                <span
                  v-if="session.startup_application != null  && (session.startup_application.user_id == session.user_auth.id)"
                >{{ $t('candidat.edit_candidat') }}</span>
                <span
                  v-else
                >{{ $t('candidat.edit_member_candidat') }}</span>
              </sp-button>

              <sp-button
                v-else
                @click="addCandidate('digital')"
                class="bg-red hover:bg-red text-white font-bold py-2 px-4 rounded inline-flex items-center"
                :disabled="(session.startup_application != null  
                && (session.startup_application.user_id != session.user_auth.id)) 
                || session.application_session != null && session.application_session.status != '1' 
                || session.application_session != null && session.application_session.limit_date == true
                || session.application_session != null && session.application_session.status == '1' && session.application_session.limit_date == true"
              >
                <img
                  class="fill-current w-4 h-4 mr-2"
                  src="../../assets/img/cand/Group Copy 2.svg"
                  alt="startup act action"
                />
                <span>{{ $t('candidat.new_candidat') }}</span>
              </sp-button>
            </div>
            <div class="px-6 text-center h-5">
              <sp-button
                v-if="(session.startup_application!=null && session.startup_application.type =='Digital' && session.startup_application.status ==0 && session.startup_application.user_id == session.user_auth.id)"
                class="text-grey"
                @click="showDelete()"
              >
                <span>{{ $t('candidat.delete') }}</span>
              </sp-button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <modal
      name="remove-app"
      :adaptive="true"
      :resizable="true"
      :maxHeight="200"
      transition="nice-modal-fade"
    >
      <div class="mb-4 p-4 text-white bg-blue">
        <h3 class="font-bold text-xl text-white">{{ $t('candidat.confirmation') }}</h3>
      </div>
      <div class="mb-4 p-4 text-center">
        <p>{{ $t('candidat.msgDelete') }}</p>
      </div>
      <div class="flex justify-center p-2">
        <sp-button
          v-if="(session.startup_application!=null && session.startup_application.status ==0)"
          theme="warning"
          size="normal"
          space="xsmall"
          @click="removeCandidate('remove-app')"
          :disabled="disabled"
        >
          <span>{{ $t('candidat.delete') }}</span>
        </sp-button>
        <sp-button
          v-if="(session.startup_application!=null && session.startup_application.status ==0)"
          theme="grey"
          size="normal"
          space="xsmall"
          @click="hide('remove-app')"
          :disabled="disabled"
        >
          <span>{{ $t('candidat.cancel') }}</span>
        </sp-button>
      </div>
    </modal>
    <modal
      name="before_add"
      :adaptive="true"
      :resizable="true"
      :maxHeight="250"
      transition="nice-modal-fade"
    >
      <div class="mb-4 p-4 text-white bg-blue">
        <h3 class="font-bold text-xl text-white">{{ $t('candidat.confirmation') }}</h3>
      </div>
      <div class="mb-4 p-4 text-center">
        <p>
          Vous avez déjà un brouillon de candidature au
          <span v-text="type_app">Label</span>, en cliquant sur continuer, ce brouillon sera effacé et une nouvelle candidature sera crée.
        </p>
      </div>
      <div class="flex justify-center p-2">
        <sp-button
          v-if="(session.startup_application!=null && session.startup_application.status ==0)"
          theme="warning"
          size="normal"
          space="xsmall"
          @click="removeCandidate('before_add')"
          :disabled="disabled"
        >
          <span>continuer</span>
        </sp-button>
        <sp-button
          v-if="(session.startup_application!=null && session.startup_application.status ==0)"
          theme="grey"
          size="normal"
          space="xsmall"
          @click="hide('before_add')"
          :disabled="disabled"
        >
          <span>{{ $t('candidat.cancel') }}</span>
        </sp-button>
      </div>
    </modal>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { CREATE_ECOSYSTEM_APP } from "@/store/actions.type";
import Button from "@/components/spKit/Button.vue";
import { SET_STARTUP_APPLICATION } from "@/store/mutations.type";

import Vue from "vue";
import VModal from "vue-js-modal";
import { SET_ApplicationMenuActive } from "@/store/mutations.type";

Vue.use(VModal, {
  dialog: true
});
export default {
  name: "candidat",
  components: {
    "sp-button": Button
  },
  data() {
    return {
      type_app: "Label",
      type_choice: null,
      disabled: false,
      user_id: "",
      isCreated: false
    };
  },
  props: {
    edit_app: {
      required: false,
      type: Boolean,
      default: false
    }
  },
  modal: {
    visible: true
  },
  computed: {
    ...mapGetters(["session"])
  },
  mounted() {
    if (this.edit_app == false) {
      this.$store.commit(SET_STARTUP_APPLICATION, null);
    }
  },
  methods: {
    disabledCheck() {
      if (this.session.startup_application == null) {
        return false;
      } else if (this.session.startup_application.status == 0) {
        return false;
      } else return true;
    },
    showDelete() {
      this.$modal.show("remove-app");
    },
    hide(modal) {
      this.$modal.hide(modal);
    },
    addCandidate(type) {
      if (!this.isCreated) {
        this.isCreated = true;
        localStorage.setItem('ecosystem', false);
        this.$store.commit(SET_ApplicationMenuActive, 1);
        if (
          this.session.startup_application != null &&
          this.session.startup_application.status == 0
        ) {
          this.type_choice = type;
          if (
            type == "prelabel" &&
            this.session.startup_application != null &&
            this.session.startup_application.type == "Label"
          ) {
            this.type_app = "Label";
            this.$modal.show("before_add");
            return true;
          }
          if (
            type == "label" &&
            this.session.startup_application != null &&
            this.session.startup_application.type == "Prélabel"
          ) {
            this.type_app = "Prélabel";
            this.$modal.show("before_add");
            return true;
          }
          if (
            type == "digital" &&
            this.session.startup_application != null &&
            this.session.startup_application.type == "Prélabel"
          ) {
            this.type_app = "Prélabel";
            this.$modal.show("before_add");
            return true;
          }
          if (
            type == "digital" &&
            this.session.startup_application != null &&
            this.session.startup_application.type == "Label"
          ) {
            this.type_app = "Label";
            this.$modal.show("before_add");
            return true;
          }
        }
        if (this.session.startup_application == null || this.edit_app == false) {
          this.$store.dispatch(CREATE_ECOSYSTEM_APP, type).then(({ data }) => {
            this.$router.push({
              name: "FormCriteria",
              params: {
                app_id: data.application.id
              }
            });
          });
        }
        // Edition application
        else {
          this.$router.push({
            name: "FormCriteria",
            params: {
              app_id: this.session.startup_application.id
            }
          });
        }
      }
    },
    removeCandidate(modal) {
      if (this.session.startup_application) {
        this.disabled = true;
        this.$store
          .dispatch(DELETE_ECOSYSTEM_APP, this.session.startup_application.id)
          .then(() => {
            this.addCandidate(this.type_choice);
            this.hide(modal);
            this.disabled = false;
          });
      }
    },
    formatDate(dateString) {
        const date = new Date(dateString);
      date.setDate(date.getDate() - 1); // Soustrait 1 jour
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0'); // Les mois sont basés sur un index 0
      const year = date.getFullYear();
      // Retourne le format DD/MM/YYYY
      return `${day}/${month}/${year}`;
    },
  }
};
</script>
<style>
.btn-add-app button {
  border-radius: 50%;
  width: 40px;
  height: 40px;
}
.btn-add-app button::after {
  content: " ";
  position: absolute;
  display: block;
  background-color: #fff;
  height: 2px;
  top: 19px;
  left: 12px;
  z-index: 9;
  width: 16px;
}
.btn-add-app button::before {
  content: " ";
  position: absolute;
  display: block;
  background-color: #fff;
  width: 2px;
  left: 19px;
  top: 12px;
  z-index: 9;
  height: 16px;
}
</style>
